module.exports = __webpack_public_path__ + "img/img-03@2x.6f38fb5a.png";